import Tasks from '../../../views/practice/tasks/Tasks';

const tasks = [
  {
    path: '/practice/tasks',
    element: <Tasks />
  }
];

export default tasks;
